/**
 * Coups de pouce, Attendus 1253 « calculer une distance réelle à partir
 * d'une distance sur une carte d'échelle connue » et 1254 « appliquer une
 * augmentation ou une diminution en pourcentage, avec ou sans coefficient
 * multiplicateur » (3e, Proportionnalité). Seconde passe 3e (2026-09-13).
 * UNE page STATIQUE par attendu.
 *   1253 « Je multiplie, puis je convertis » : 4 cm sur une carte au
 *     1/500 000 ; dans la réalité, 500 000 fois plus : 4 × 500 000 =
 *     2 000 000 cm ; le tableau des unités de longueur (cycle 3) place
 *     2 000 000 cm sur 20 km. L'erreur principale est le rang (2 km, 200 km).
 *   1254 « 100 % + 20 % = 120 % » : la question en tête (150 € après
 *     + 20 % ? après − 20 % ?), deux colonnes (prof 2026-09-19) : à gauche
 *     la hausse, barre 100 % en cinq cases de 30 € plus une case orange,
 *     150 + 30 = 180 € ou 150 × 1,2 ; à droite la baisse, la même barre
 *     avec la cinquième case barrée en rouge, 150 − 30 = 120 € ou
 *     150 × 0,8 ; la réponse en pied.
 *
 * SACRIFIÉS (gen1253, gen1254 self-tests) : (4 cm ; 1/500 000) ; (150 € ;
 * 20 %) dans les deux sens, le coefficient 1,2 / 0,8 n'est pas sacrifié
 * (fait à connaître, exemption comme 1047).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';
const BLEU_CLAIR = '#DBEAFE';
const ORANGE_CLAIR = '#FED7AA';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const gras = (t, couleur = ENCRE) => `<tspan font-weight="bold" fill="${couleur}">${t}</tspan>`;

// ─── 1253 : 4 cm au 1/500 000 ──────────────────────────────────────────────
const UNITES = ['km', 'hm', 'dam', 'm', 'dm', 'cm'];
// 2 000 000 cm : un chiffre par colonne en partant du 0 des unités sous cm, le reste (20) dans la colonne km
const CHIFFRES = ['20', '0', '0', '0', '0', '0'];
const TX0 = 70; const TW = 44; const TY = 96;
const TABLEAU = UNITES.map((u, k) => {
    const x = TX0 + k * TW;
    const km = k === 0; const cm = k === 5;
    return `<rect x="${x}" y="${TY}" width="${TW}" height="24" fill="${km ? ORANGE_CLAIR : BLEU_CLAIR}" stroke="${BLEU}" stroke-width="1.2"/>
  <text x="${x + TW / 2}" y="${TY + 17}" font-size="12" font-weight="bold" text-anchor="middle" fill="${km ? ORANGE : BLEU}">${u}</text>
  <rect x="${x}" y="${TY + 24}" width="${TW}" height="26" fill="white" stroke="${BLEU}" stroke-width="1.2"/>
  <text x="${x + TW / 2}" y="${TY + 43}" font-size="15" font-weight="bold" text-anchor="middle" fill="${km ? ORANGE : cm ? ENCRE : GRIS}">${CHIFFRES[k]}</text>`;
}).join('\n  ');

const SVG_ECHELLE = svg(
    'Sur une carte à l’échelle 1 sur 500 000, 4 centimètres. Dans la réalité, c’est 500 000 fois plus : 4 fois 500 000 égale 2 000 000 centimètres. Dans le tableau des unités de longueur, kilomètre, hectomètre, décamètre, mètre, décimètre, centimètre, le chiffre des unités 0 va sous cm, un chiffre par colonne, et il reste 20 dans la colonne km : 20 kilomètres. 2 000 000 cm, c’est 20 km.',
    `${ligne(36, `Échelle ${gras('1/500 000')} : dans la réalité, c’est 500 000 fois plus.`, 12)}
  ${ligne(62, `4 cm × 500 000 = ${gras('2 000 000 cm')}`, 15)}
  ${TABLEAU}
  <text x="${TX0 + 5 * TW + TW / 2}" y="${TY + 64}" font-size="10" text-anchor="middle" fill="${GRIS}">le 0 des unités sous cm</text>
  ${ligne(190, `Un chiffre par colonne depuis cm, le reste va dans km : ${gras('20 km', ORANGE)}.`, 13)}
  ${ligne(216, 'Je multiplie par l’échelle, puis je convertis avec le tableau.', 12)}
  ${ligne(238, 'Ce n’est ni 2 km ni 200 km : je compte les colonnes.', 12, GRIS)}`,
    254,
);

// ─── 1254 : 150 € + 20 % et 150 € − 20 %, en deux colonnes (prof 2026-09-19) ─────────────
const ROUGE = '#DC2626';
const ROUGE_CLAIR = '#FECACA';
const CW = 26;   // largeur d'une case de 20 %
/** Une barre de cinq cases de 30 € (100 % = 150 €), plus une case en plus (hausse) ou une case barrée (baisse). */
const barre = (x0, y, hausse) => {
    const c = hausse ? ORANGE : ROUGE; const cc = hausse ? ORANGE_CLAIR : ROUGE_CLAIR;
    const cases = Array.from({ length: 5 }, (_, k) => {
        const retiree = !hausse && k === 4;
        return `<rect x="${x0 + k * CW}" y="${y}" width="${CW}" height="22" fill="${retiree ? cc : BLEU_CLAIR}" stroke="${retiree ? c : BLEU}" stroke-width="1.2"/>
  <text x="${x0 + k * CW + CW / 2}" y="${y + 15}" font-size="9" font-weight="bold" text-anchor="middle" fill="${retiree ? c : BLEU}">${retiree ? '− 30' : '30 €'}</text>`
        + (retiree ? `<line x1="${x0 + k * CW + 3}" y1="${y + 3}" x2="${x0 + (k + 1) * CW - 3}" y2="${y + 19}" stroke="${c}" stroke-width="1.4"/>` : '');
    });
    if (hausse) {
        cases.push(`<rect x="${x0 + 5 * CW}" y="${y}" width="${CW}" height="22" fill="${cc}" stroke="${c}" stroke-width="1.6"/>
  <text x="${x0 + 5 * CW + CW / 2}" y="${y + 15}" font-size="9" font-weight="bold" text-anchor="middle" fill="${c}">+ 30</text>`);
    }
    const nb = hausse ? 6 : 4;   // cases sous l'accolade du total
    return [
        `<text x="${x0 + 2.5 * CW}" y="${y - 6}" font-size="10" font-weight="bold" text-anchor="middle" fill="${BLEU}">100 % = 150 €</text>`,
        ...cases,
        `<path d="M ${x0} ${y + 27} L ${x0} ${y + 33} L ${x0 + nb * CW} ${y + 33} L ${x0 + nb * CW} ${y + 27}" fill="none" stroke="${GRIS}" stroke-width="1.2"/>`,
        `<text x="${x0 + nb * CW / 2}" y="${y + 46}" font-size="11" font-weight="bold" text-anchor="middle" fill="${ENCRE}">${hausse ? '120 % = 180 €' : '80 % = 120 €'}</text>`,
    ].join('\n  ');
};
const col = (x, y, contenu, taille = 11, couleur = ENCRE) => `<text x="${x}" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const XG = 100; const XD = 300;   // centres des deux colonnes

const SVG_HAUSSE = svg(
    'Question : que deviennent 150 euros après une augmentation de 20 pour cent ? Et après une diminution de 20 pour cent ? Deux colonnes. À gauche, l’augmentation : une barre de cinq cases de 30 euros, 100 pour cent égale 150 euros, plus une case orange de 30 euros ; 20 pour cent de 150 égale 30, 150 plus 30 égale 180 euros ; ou d’un coup, 100 plus 20 égale 120 pour cent, 150 fois 1,2 égale 180 euros. À droite, la diminution : la même barre, la cinquième case barrée en rouge ; 150 moins 30 égale 120 euros ; ou d’un coup, 100 moins 20 égale 80 pour cent, 150 fois 0,8 égale 120 euros. Réponse : plus 20 pour cent donne 180 euros, moins 20 pour cent donne 120 euros. Le coefficient, c’est le pourcentage final écrit en nombre.',
    `${ligne(24, `${gras('Question :')} que deviennent 150 € après + 20 % ? Et après − 20 % ?`, 12)}
  <line x1="200" y1="36" x2="200" y2="212" stroke="${GRIS}" stroke-width="0.8" stroke-dasharray="3 3"/>

  <!-- colonne gauche : la hausse -->
  ${col(XG, 52, 'Augmentation de 20 %', 12, ORANGE).replace('<text', '<text font-weight="bold"')}
  ${barre(XG - 3 * CW, 74, true)}
  ${col(XG, 148, `20 % de 150 = 150 ÷ 5 = ${gras('30 €', ORANGE)}`)}
  ${col(XG, 166, `150 + 30 = ${gras('180 €')}`)}
  ${col(XG, 190, `ou d’un coup : 100 % + 20 % = 120 %`, 10, GRIS)}
  ${col(XG, 206, `150 × ${gras('1,2', ORANGE)} = ${gras('180 €')}`)}

  <!-- colonne droite : la baisse -->
  ${col(XD, 52, 'Diminution de 20 %', 12, ROUGE).replace('<text', '<text font-weight="bold"')}
  ${barre(XD - 2.5 * CW, 74, false)}
  ${col(XD, 148, `20 % de 150 = 150 ÷ 5 = ${gras('30 €', ROUGE)}`)}
  ${col(XD, 166, `150 − 30 = ${gras('120 €')}`)}
  ${col(XD, 190, `ou d’un coup : 100 % − 20 % = 80 %`, 10, GRIS)}
  ${col(XD, 206, `150 × ${gras('0,8', ROUGE)} = ${gras('120 €')}`)}

  ${ligne(236, `${gras('Réponse :')} + 20 % → ${gras('180 €', ORANGE)} ; − 20 % → ${gras('120 €', ROUGE)}.`, 12)}
  ${ligne(258, 'Le coefficient, c’est le pourcentage final écrit en nombre : 120 % = 1,2 ; 80 % = 0,8.', 11, GRIS)}`,
    272,
);

const AIDE_ECHELLE = { pages: [{ titre: 'Je multiplie, puis je convertis', svg: SVG_ECHELLE }] };
const AIDE_HAUSSE = { pages: [{ titre: '100 % + 20 % = 120 %', svg: SVG_HAUSSE }] };

const CP_1253 = {
    flash_texte_trou_saisie: AIDE_ECHELLE,
    distance_qcm_unique: AIDE_ECHELLE,
    sens_tableau_vf: AIDE_ECHELLE,
};
export const CP_1254 = {
    flash_texte_trou_saisie: AIDE_HAUSSE,
    valeur_qcm_unique: AIDE_HAUSSE,
    coefficient_qcm_unique: AIDE_HAUSSE,
    sens_tableau_vf: AIDE_HAUSSE,
};

export default CP_1253;
